import loginModel from './login';

const SESSION_INVALIDATED_KEY = 'einstein_session_invalidated';

export default {
    apiError: function(errorResponse, router) {
        let returnError = false;
        if (errorResponse.response) {
            const status = errorResponse.response.status;
            const message = errorResponse.response.data?.message;
            const reason = errorResponse.response.data?.reason;

            if (status === 401) {
                sessionStorage.setItem(SESSION_INVALIDATED_KEY, '1');
                loginModel.logout(router);
            }

            if (reason) {
                returnError = reason;
            } else if (message) {
                returnError = 'Error: ' + message;
            }
        } else {
            returnError = errorResponse.toString();
        }

        return returnError;
    },

    SESSION_INVALIDATED_KEY
};
